var exports = {
  "common-title-col": "xcc377c0b--51d340--common-title-col",
  "common-rate-col": "xcc377c0b--51d340--common-rate-col",
  "common-sum-col": "xcc377c0b--51d340--common-sum-col",
  "common-term-col": "xcc377c0b--51d340--common-term-col",
  "common-payment-col": "xcc377c0b--51d340--common-payment-col",
};

module.exports = exports;
